import type { ListBuilderList } from '../../../types';

/**
 * Pending Match list - licenses with at least one pending_review match
 * candidate awaiting human review.
 *
 * This is the actionable intake queue for compliance officers — only
 * licenses where the matchmaker has actually surfaced a registry candidate
 * appear here. Licenses with no candidates yet live on the Under Review tab.
 */
export const pendingMatchList: ListBuilderList = {
	id: 'default-licenses-pending-match',
	cacheTTL: 300000,
	name: 'Pending Match',
	type: 'default',
	active: true,
	sortOrder: 0,
	filterRules: {
		licenseMatchStatus: {
			defaultValue: { id: 'has_pending_match', label: 'Pending Match' },
			locked: true,
			hidden: true,
		},
		licenseSalesRep: {
			defaultValue: [{ id: 'ME', label: 'Me' }],
			applyDefaultIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [
					{ type: 'rule', action: 'licenses:view:any', negated: true },
				],
			},
			lockedIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [
					{ type: 'rule', action: 'licenses:view:any', negated: true },
				],
			},
			hiddenIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [
					{ type: 'rule', action: 'licenses:view:any', negated: true },
				],
			},
		},
	},
	inheritsFrom: 'default-licenses-all',
};
